import { Box } from '@mui/material';

import { LoginCta } from './LoginCta';
import { LoginFooter } from './LoginFooter';

export function LoginPanel() {
  return (
    <Box
      sx={{
        width: '40%',
        paddingTop: '10rem',
        paddingBottom: '2rem',
        paddingX: '2rem',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <LoginCta />
      <LoginFooter />
    </Box>
  );
}
